<template>
  <div
    class="zs-login"
    :class="bgClass">
    <div class="zs-title-warp">
      <p class="zs-title">{{ appName }}</p>
    </div>
    <div class="zs-form-warp">
      <el-form
        ref="form"
        status-icon
        :model="loginForm"
        :rules="rules">
        <el-form-item prop="account">
          <el-input
            ref="accountInput"
            v-model="loginForm.account"
            placeholder="请输入用户名"
            autofocus
            @keyup.enter.native="submitUser"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            placeholder="请输入密码"
            type="password"
            @keyup.enter.native="submitUser"></el-input>
        </el-form-item>
        <el-form-item prop="captcha">
          <div class="identify-inline">
            <el-input
              v-model="loginForm.captcha"
              class="identify-input"
              placeholder="请输入验证码"
              :maxlength="4"
              @keyup.enter.native="submitUser"></el-input>
            <div class="identify-image">
              <identify-code ref="code" />
            </div>
          </div>
        </el-form-item>
        <div class="zs-login-submit">
          <el-button
            :loading="loading"
            type="primary"
            @click="submitUser">登&nbsp;&nbsp;&nbsp;&nbsp;录</el-button>
        </div>
      </el-form>
    </div>
    <div class="put-on-record">
      <!-- <div>中国检验认证集团浙江有限公司，衢州市商务局</div> -->
      <div>
        备案号：浙ICP备14003353号
        <!-- <img :src="baPng" />
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502005484"
          target="_blank">浙公网安备 33010502005484号</a> -->
      </div>
    </div>
  </div>
</template>
<script>
import md5 from 'js-md5'
import IdentifyCode from './identify-code.vue'
const baPng = require('@/assets/images/beian.png')
import { locationMap } from '@/utils/baseData'
export default {
  name: 'WfLoginForm',
  components: { IdentifyCode },
  props: {},
  data() {
    return {
      redirct: '',
      loading: false,
      hostname: location.hostname,
      baPng,
      loginForm: { account: '', password: '', captcha: '' },
      rules: {
        account: [{ required: true, message: ' ', trigger: 'blur' }],
        password: [{ required: true, message: ' ', trigger: 'blur' }],
        captcha: [{ required: true, message: ' ', trigger: 'blur' }]
      },
      locationMap
    }
  },
  computed: {
    appName({ hostname, locationMap }) {
      return locationMap[hostname]
    },
    bgClass({ hostname }) {
      return hostname.split('.')
    }
  },
  mounted() {
    // document.title = this.appName
    // this.redirct = this.$route.query.redirct
  },
  methods: {
    submitUser() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const { account, password, captcha } = this.loginForm
          const captchaKey = this.$refs.code.getIdentifyKey()
          if (!captchaKey) {
            this.$message.error('当前验证码无效，请刷新')
            return false
          }
          this.loading = true
          const timestamp = +new Date()
          const post = md5.hex(md5.hex(account + password) + timestamp)
          this.$store.dispatch('account/login', {
            payload: { account: account, password: post, timestamp: timestamp, captcha, captchaKey },
            success: () => {
              this.loading = false
              this.$message.success('登录成功')
              this.$router.push({ path: '/main' })
              // if (this.redirct) {
              //   this.$router.push({ path: this.redirct })
              // } else {
              //   this.$router.push({ path: res })
              // }
            },
            fail: (errMsg) => {
              this.$refs.code.getIdentifyCode()
              this.$message.error(errMsg)
              this.loginForm.captcha = ''
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.zs-login {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &.localhost {
    background: url('./image/bg.jpg') center / cover;
  }
  &.zzjd {
    background: url('./image/bg.jpg') center / cover;
  }
  &.ccicjd {
    background: url('./image/bg.jpg') center / cover;
  }
  &.zjfw {
    background: url('./image/bg.jpg') center / cover;
  }
  &.zzfw {
    background: url('./image/bg.png') center / cover;
  }
  &.cciczj {
    background: url('./image/bg.png') center / cover;
  }
  &.zl {
    background: url('./image/bg.png') center / cover;
  }
  .identify-inline {
    display: flex
    align-items: center

    .identify-input {
      flex: 1
      margin-right: 12px
    }
    .identify-image {
      width: 90px;
      flex: 0 0 90px;
      height: 32px
    }
  }
  .zs-title-warp {
    margin-bottom: 15px;

    .zs-title {
      color: #fff;
      letter-spacing: 2px;
      text-align: center;
      font-size: 36px;
      font-weight: 600;
      position: relative;
    }
  }

  .zs-form-warp {
    width: 450px;
    height: 253px;
    background: url('./image/t-bg.png') center / cover;
    padding: 36px 60px;

    .zs-login-submit {
      .el-button {
        width: 100%;
      }
    }
  }

  .put-on-record {
    position: fixed;
    bottom: 5px;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 13px;
    color: #fff;
    display: flex;
    flex-direction column
    align-items: center;
    justify-content: center;

    a {
      color: #fff;
    }

    img {
      margin: 0 4px;
    }
  }
}
</style>
